module.exports = "<div #iFrameParent layout=\"row\" class=\"page-height\">\n  <iframe #iFrame id=\"homeIframe\" (load)=\"onIframeLoad()\" frameborder=\"0\" class=\"homePageIframe\" [src]=\"homeIFrameUrl\"></iframe>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/clients/client/content/content.component.html
// module id = 2178
// module chunks = 0